import { AlarmTypeColorMapping } from '@hakimo-ui/hakimo/types';
import { DEFAULT_ALARM_TYPE_COLOR_CLASS } from '../constants';

let alarmTypeToColorClassMap = new Map<string, string>();

export function setColorMappings(
  colorMappings: AlarmTypeColorMapping[] = []
): void {
  const newMap = new Map<string, string>();
  if (colorMappings) {
    for (const mapping of colorMappings) {
      const colorClass = mapping.css_class || DEFAULT_ALARM_TYPE_COLOR_CLASS;
      for (const type of mapping.alarm_types) {
        newMap.set(type.toLowerCase(), colorClass);
      }
    }
  }
  alarmTypeToColorClassMap = newMap;
}

export function getAlarmTypeColorClass(alarmType: string): string {
  return (
    alarmTypeToColorClassMap.get(alarmType.toLowerCase()) ||
    DEFAULT_ALARM_TYPE_COLOR_CLASS
  );
}

export function hasAlarmTypeColor(alarmType: string): boolean {
  return alarmTypeToColorClassMap.has(alarmType.toLowerCase());
}
